<template>
  <div class="con-wrap">
    <el-form
      size="medium"
      :inline="true"
      :model="queryForm"
      ref="queryForm"
      class="input-form-inline"
      @submit.native.prevent
    >
      <div>
        <el-form-item class="r-20" prop="sysType">
          <el-select v-model="queryForm.sysType" placeholder="系统类型">
            <el-option
              v-for="item in drivingState"
              :key="item.id"
              :label="item.label"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="r-20" prop="appId">
          <el-input
            v-model="queryForm.appId"
            @keyup.enter.native="query"
            placeholder="应用ID"
          ></el-input>
        </el-form-item>
        <el-button
          v-if="hasPerm('app:version:list')"
          type="primary"
          @click="query"
          >查询</el-button
        >
        <el-button v-if="hasPerm('app:version:list')" @click="reset"
          >取消</el-button
        >
      </div>
      <div style="margin-bottom: 20px">
        <el-button
          size="medium"
          v-if="hasPerm('app:version:save')"
          type="primary"
          @click="uploadBtn"
          >上传</el-button
        >
        <el-button
          size="medium"
          v-if="hasPerm('app:version:delete')"
          type="danger"
          @click="delAppVersion"
          >删除</el-button
        >
      </div>
    </el-form>
    <el-table
      ref="multipleTable"
      :data="tableData"
      tooltip-effect="dark"
      style="width: 100%"
      size="mini"
      stripe
      height="560px"
      @row-click="handleClickTableRow"
      @selection-change="handleSelectionChange"
    >
      <el-table-column
        type="selection"
        width="24"
        align="center"
        style="padding: 0"
      ></el-table-column>
      <el-table-column type="index" label="序号" width="55"></el-table-column>
      <el-table-column prop="appId" label="应用ID"></el-table-column>
      <el-table-column prop="sysType" label="系统类型">
        <template slot-scope="scope">
          <span v-if="scope.row.sysType == 1">android</span>
          <span v-else-if="scope.row.sysType == 2">ios</span>
        </template>
      </el-table-column>
      <el-table-column prop="version" label="版本"></el-table-column>
      <el-table-column
        prop="fileName"
        label="文件名"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="md5"
        label="MD5"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="addTime"
        label="上传时间"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column label="操作" width="260" fixed="right">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="text"
            v-if="hasPerm('upgrade:package:list')"
            @click.stop="fileDownload(scope.row)"
            >文件下载</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page.sync="currentPage"
      :page-size="limit"
      layout="total, prev, pager, next, jumper"
      :total="total"
    ></el-pagination>
    <!--上传升级包-->
    <el-dialog
      title="升级包上传"
      :visible.sync="packageUploadVisible"
      class="vehicle-dialog"
    >
      <el-form
        :rules="uploadRules"
        ref="uploadForm"
        :model="uploadForm"
        size="mini"
        :inline="true"
      >
        <div>
          <el-form-item class="upload-box" label="上传文件">
            <el-upload
              class="upload-demo"
              ref="upload"
              :with-credentials="true"
              :multiple="false"
              :limit="1"
              accept=".apk"
              :data="myData()"
              :file-list="fileList"
              :on-change="addFile"
              :action="uploadUrl()"
              :http-request="uploadSectionFile"
              :auto-upload="false"
            >
              <el-button
                size="small"
                type="primary"
                style="height: 28px;line-height:28px"
                >点击上传</el-button
              >
            </el-upload>
          </el-form-item>
          <el-form-item prop="md5" label="MD5校验">
            <el-input v-model="uploadForm.md5" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item prop="sysType" label="系统类型">
            <el-select v-model="uploadForm.sysType" placeholder="系统类型">
              <el-option
                v-for="item in drivingState"
                :key="item.id"
                :label="item.label"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="appId" label="应用名称">
            <el-select v-model="uploadForm.appId" placeholder="应用名称">
              <el-option
                v-for="item in appList"
                :key="item.appId"
                :label="item.name"
                :value="item.appId"
              ></el-option>
            </el-select>
          </el-form-item>
          <div style="text-align:right">
            <span slot="footer" class="dialog-footer">
              <el-button type="primary" @click="importCommit">上传</el-button>
            </span>
          </div>
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      queryForm: {
        appId: "",
        sysType: "",
      },
      currentPage: 1,
      limit: 10,
      total: 0,
      tableVal: [],
      tableData: [],
      drivingState: [
        {
          id: 1,
          label: "android",
        },
        {
          id: 2,
          label: "ios",
        },
      ],
      uploadForm: {},
      uploadRules: {
        md5: [
          {
            required: true,
            trigger: "change",
            message: "请输入MD5校验码",
          },
        ],
        sysType: [
          {
            required: true,
            trigger: "change",
            message: "请选择系统类型",
          },
        ],
        appId: [
          {
            required: true,
            trigger: "change",
            message: "请选择应用名称",
          },
        ],
      },
      appList: [],
      fileList: [],
      fileSizeIsSatisfy: false,
      packageUploadVisible: false,
      loading: "",
    }
  },
  created() {
    this.getVersionList()
    this.getAppList()
  },
  methods: {
    async getVersionList() {
      let _this = this
      let obj = {}
      obj.sysType = _this.queryForm.sysType
      obj.appId = _this.queryForm.appId
      obj.limit = _this.limit
      obj.page = _this.currentPage
      let { data: res } = await _this.$axios.get("/api/app/version/list", {
        params: obj,
      })
      if (res.code == 1) {
        _this.tableData = res.data.list
        _this.total = res.data.totalCount
      }
    },
    query() {
      this.getVersionList()
    },
    reset() {
      this.$resetForm(this, "queryForm")
      this.getVersionList()
    },
    async getAppList() {
      let _this = this
      let { data: res } = await _this.$axios.get("/api/news/push/app/options")
      if (res.code == 1) {
        _this.appList = res.data
      } else {
        _this.$message.warning(res.msg)
      }
    },
    uploadBtn() {
      this.uploadForm = {}
      this.$resetForm(this, "uploadForm")
      this.loading = ""
      this.fileList = []
      this.packageUploadVisible = true
    },
    myData() {
      return {
        appId: this.uploadForm.appId,
        sysType: this.uploadForm.sysType,
        md5: this.uploadForm.md5,
      }
    },
    addFile(file, fileList) {
      this.fileList = fileList
      //限制上传文件为10M
      this.fileSizeIsSatisfy = file.size < 50 * 1024 * 1024 ? true : false
      this.extension = file.name.substring(file.name.lastIndexOf(".") + 1)
      console.log(file.type)
    },
    uploadUrl() {
      return "/api/app/version"
    },
    async uploadSectionFile(parm) {
      let _this = this
      let fileObj = parm.file
      // FormData 对象
      let form = new FormData()
      // 文件对象
      form.append("file", fileObj)
      form.append("sysType", this.uploadForm.sysType)
      form.append("appId", this.uploadForm.appId)
      form.append("md5", this.uploadForm.md5)
      let { data: res } = await _this.$axios.post("/api/app/version", form)
      if (res.code == 1) {
        _this.$message.success("上传成功")
        _this.packageUploadVisible = false
        //导入成功后清空upload
        _this.$refs.upload.clearFiles()
        _this.fileList = []
        _this.getVersionList()
      } else {
        _this.$refs.upload.clearFiles()
        _this.fileList = []
        _this.$message.warning(res.msg)
      }
      _this.loading.close()
    },
    async importCommit() {
      console.log(this.myData())
      this.$refs.uploadForm.validate((valid) => {
        if (valid) {
          if (this.fileList.length <= 0) {
            this.$message.warning("请至少上传一个文件！")
            return
          }
          if (this.extension !== "apk") {
            this.$message.warning("上传失败！请上传apk文件！")
            this.$refs.upload.clearFiles()
            this.fileList = []
            return
          }
          if (!this.fileSizeIsSatisfy) {
            this.$message.warning("上传失败！文件大小超过50M！")
            this.$refs.upload.clearFiles()
            this.fileList = []
            return
          }
          this.$refs.upload.submit()
          this.loading = this.$loading({
            lock: false,
            text: "文件上传中，请稍后...",
            spinner: "el-icon-loading",
            background: "rgba(255,255,255,.8)",
            target: document.querySelector(".el-dialog"),
          })
        }
      })
    },
    fileDownload(rowData) {
      this.$confirm("确定下载该升级包吗？", "系统提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        window.location.href = rowData.url
      })
    },
    delAppVersion() {
      let _this = this
      //多选删除
      let ids = _this.$getIds(_this.tableVal)
      if (!ids) {
        return
      }
      _this
        .$confirm("确定删除吗？", "系统提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
        .then(async () => {
          let { data: res } = await _this.$axios.delete("/api/app/version", {
            data: JSON.stringify(ids),
          })
          if (res.code == 1) {
            _this.$message.success("操作成功")
            let totalPage = Math.ceil((_this.total - 1) / 10)
            let currentPage =
              _this.currentPage > totalPage ? totalPage : _this.currentPage
            _this.currentPage = currentPage < 1 ? 1 : currentPage
            _this.getVersionList()
          } else {
            _this.$message.warning(res.msg)
          }
        })
    },
    //选择数据变化监控
    handleSelectionChange(val) {
      this.tableVal = val
    },
    handleClickTableRow(row, event, column) {
      console.log(row)
      console.log(column)
      this.$refs.multipleTable.toggleRowSelection(row)
    },
    //pagesize改变时触发
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`)
    },
    //页数改变时触发
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`)
      this.currentPage = val
      this.getVersionList()
    },
  },
}
</script>

<style lang="scss" scoped>
.con-wrap {
  padding: 0 20px;
  background: #fff;
}
//升级包上传
.vehicle-dialog /deep/ .el-dialog {
  width: 600px;
}
.vehicle-dialog /deep/ .el-form-item__label {
  width: 140px;
  height: 32px;
  margin-left: 20px;
  text-align: left;
  color: #343434;
  font-size: 14px;
}
.vehicle-dialog /deep/ .el-form-item__content {
  width: 360px;
  height: auto;
}
.upload-box /deep/ .el-form-item__label {
  padding-left: 11px;
  position: relative;
}
.upload-box /deep/ .el-form-item__label::before {
  content: "*";
  color: #f56c6c;
  position: absolute;
  left: 0px;
  top: 1px;
}
.con-wrap /deep/ .el-icon-loading {
  font-size: 30px;
}
</style>
